import { HttpError } from '@/api/_base';
import type { useT } from '@/i18n/useT';

type LoginT = ReturnType<typeof useT<'login'>>;

// Backend auth error codes shared across SignIn, SignUp, Landing and TgQuick.
// 9370/4007 both mean "wrong account or password" (two distinct backend
// checks, same user-facing message).
const AUTH_ERROR_MESSAGES = {
  9003: 'account_in_use',
  9194: 'account_in_use',
  9229: 'account_locked',
  9370: 'login_wrong_credentials',
  4007: 'login_wrong_credentials',
  9371: 'login_wrong_credentials',
  9372: 'pw_rate_limit_5min',
  9373: 'pw_rate_limit_10min',
  9374: 'pw_rate_limit_30min',
  9375: 'account_frozen',
} as const satisfies Record<number, Parameters<LoginT>[0]>;

/** Maps the shared auth error codes to their login-namespace message. Returns
 *  null when `e` isn't one of these codes, so callers can fall through to a
 *  page-specific check or a generic failure message. */
export function mapAuthError(e: unknown, t: LoginT): string | null {
  if (!(e instanceof HttpError) || e.code === undefined) return null;
  const key = AUTH_ERROR_MESSAGES[e.code as keyof typeof AUTH_ERROR_MESSAGES];
  return key ? t(key) : null;
}
